// 所有报错码
export const NetErrorCode = [
  202, 203, 204, 205, 206, 207, 208, 209, 210, 400, 401, 402, 403, 404, 405,
  406, 407, 501, 502, 503, 504, 1101, 1102, 1103, 1201, 1202, 1203, 1204, 1205,
  1206, 1207, 1208, 1209, 1210, 1211, 1212, 1213, 1214, 1215, 1216, 1217, 1218,
  1219, 1220, 1221, 1222, 1223, 1224, 1226, 1301, 1302, 1303, 1304, 1305, 1306,
  1307, 1308, 1309, 1310, 1311, 1312, 1313, 1314, 1315, 1316, 1317, 1318, 1319,
  1320, 1321, 1322, 1323, 1324, 1325, 1326, 1327, 1328, 1329, 1330, 1331, 1332,
  1333, 1334, 1335, 1336, 1337, 1338, 1339, 1340, 1341, 1342, 1343, 1344, 1345,
  1501, 1502, 1503, 1504, 1601, 1602, 1604, 1605, 1701, 1702, 1801, 2004, 2008,
  2101, 2102, 2103, 2301, 2302, 2303, 2304, 2305, 2306, 2307, 3001, 3002, 3003,
  3008, 3281, 3282, 3283, 3284, 3301, 3302, 3303, 3304, 10003, 10004, 10005,
  10006, 10007, 10008, 10009, 10010, 10011, 10012, 10013, 10014, 10015, 10016,
  103, 110, 202, 203, 204, 207, 209, 210, 211, 212, 213, 301, 302, 11001, 11002,
  16001, 16002, 16003, 16004, 16005, 16006, 16007, 16008, 16009, 16010, 16011,
  16012, 16013, 16014, 16015, 16016, 16017, 16018, 17000, 4201, 4202, 4203,
  4204, 4205, 4206, 4207,
];
// 特殊报错码
export const NetErrorCodeSpecial = [
  1206, 1229, 1211, 1219, 1220, 1221, 1325, 2302, 2303, 2304, 2305, 3282, 3283,
  3284, 3304, 10003, 10006, 10007,
];
// 忽略错误码，程序处理
export const IgnoreErrorCode = [
  1603, // 游戏被锁
  1607, // 充值拦截
  2002, // 请先完成KYC验证
  2003, // 暂未开启KYC
  2005, // 請先綁定 CPF 信息
  2006, // 請先綁定 CPF 和 姓名 信息
  2007, // 請先綁定認證需要的證件信息
  1348, // 您輸入的CPF已與一個帳號綁定。請使用該CPF登入。
  1349, // 您輸入的電子郵件已與一個帳號綁定。請使用該電子郵件登入。
  1350, // 電子郵件：{email} 已連結到一個帳號。您要使用Face ID登入嗎？
  1351, // 您輸入的電話號碼已與一個帳號綁定。請使用該電話號碼登入。
  1352, // 電話號碼：{number} 已連結到一個帳號。您要使用Face ID登入嗎？
  1353, // CPF：{cpf} 已連結到一個帳號。您要使用Face ID登入嗎？
  1354, // 此帳號已連結到一個CPF。忘記密碼了嗎？您可以使用Face ID登入。
];

export enum ErrorNumberEnum {
  TokenError = 401, //TOKEN无效
  TokenErrorDel = 505, //TOKEN被挤掉
  CheckInSuc = 3281, //签到已成功 old：16201
  VerifyCodeError = 1326, //验证码错误 old：1008
  EnterGameLock = 1603, //进入游戏被lock
  EnterGameDeposit = 1607, //进入游戏需要充值
  RegisterTooLong = 1321, //注册IP超出半径
  RaceTicketMulti = 3601, // "有未使用的门票,不能在购买"
  RaceTicketFindErr = 3602, // "无可用门票"
  RaceTicketBuyErr = 3603, // "购买门票失败"
  RaceUseItemErr = 3604, // "使用道具失败"
  RaceEnterGameErr = 3605, // "当前轮次不支持改游戏"
  RaceJoinGameErr = 3606, // "参与比赛失败"
  RaceJoinGameRepeatErr = 3607, // "当前比赛已经参与"
  RaceRoundCloseErr = 3608, // "当前轮次已经结束"
  RaceRoundNotOpenErr = 3609, // "当前轮次暂未开始"
  RaceRoundDenyGameErr = 3610, // "当前轮次不支持该游戏"
  RaceNotJoinErr = 3611, // "请先参与当前轮次比赛"
  InitRacePointErr = 3612, // "初始化比赛积分失败"
  GetRacePointErr = 3613, // "获取比赛积分失败"
  ActionRaceExpireErr = 3614, // "比赛已经结束"
  RacePointLessErr = 3615, // "比赛积分不足"
  RaceRoundUserGameClose = 3616, // "你的比赛时间已到"
  InsufficientBalance = 11405, // 余额不足
}
